import { saveAssetGroupAndLinkedData } from '@bingads-webui-campaign-react/perf-max-step-wizard';

export const saveAssetGroup = saveAssetGroupAndLinkedData;
